import i18next from 'i18next';

/**
 * Actions of an order that left the draft status, hosted by the `...` button of the selectors row.
 * They never depend on a selection — the table carries no checkbox — so the export always covers the
 * whole order.
 *
 * Each status pairs the export with the transition sending the order one step back in the flow and
 * with the delivery edition (COR-1771), each gated by its own right: with neither of the two the
 * export stands alone, and the caller displays it as an icon button rather than as a menu. The
 * delivery note export (COR-1728) joins them on a prepared order, gated by no right — reaching the
 * page is enough.
 *
 * @param {Object} params
 * @param {Object} [params.revertAction] - The backward transition of the status, when allowed
 * @param {string} params.revertAction.id - DOM id of the action
 * @param {string} params.revertAction.label - Label of the action
 * @param {Function} params.revertAction.handleClick - Transition handler
 * @param {Function} [params.onEditDelivery] - Delivery edition handler, when allowed
 * @param {Function} params.onExport - Export handler
 * @param {Function} [params.onExportDeliveryNote] - Delivery note export handler, prepared orders only
 *
 * @returns {Array<Object>} The Button dropdown actions
 */
export const getPostDraftExternalOrderActions = ({
  revertAction,
  onEditDelivery,
  onExport,
  onExportDeliveryNote,
}) => {
  const actions = [];

  if (revertAction) {
    actions.push({
      id: revertAction.id,
      label: revertAction.label,
      icon: '/images/inpulse/edit-pen-black-small.svg',
      handleClick: revertAction.handleClick,
    });
  }

  if (onEditDelivery) {
    actions.push({
      id: 'action-edit-order-delivery',
      label: i18next.t('EXTERNAL_ORDERS.FORM.EDIT_DELIVERY'),
      icon: '/images/inpulse/calendar-black-small.svg',
      handleClick: onEditDelivery,
    });
  }

  actions.push({
    id: 'action-export-order',
    label: i18next.t('EXTERNAL_ORDERS.FORM.EXPORT_ORDER'),
    icon: '/images/inpulse/file-download-black-small.svg',
    handleClick: onExport,
  });

  if (onExportDeliveryNote) {
    actions.push({
      id: 'action-export-order-delivery-note',
      label: i18next.t('EXTERNAL_ORDERS.FORM.EXPORT_DELIVERY_NOTE'),
      icon: '/images/inpulse/file-download-black-small.svg',
      handleClick: onExportDeliveryNote,
    });
  }

  return actions;
};
